// extracted by mini-css-extract-plugin
module.exports = {"spinner_in_page_center":"spinner_spinner_in_page_center__3TeG0"};